import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { NodeDate, NodeUsers } from '@/components/nodes'
import { User } from 'lucide-react'
import type { User as UserType } from '@/types'

interface HistoryCardProps {
  /** The user who created the node */
  creator: UserType
  /** Date for when the node was created (Date object or ISO string) */
  createdAt: string | Date
  /** Date for when the node was last updated (Date object or ISO string) */
  updatedAt: string | Date
  /** Optional custom title for the card (defaults to "History") */
  title?: string
  /** Optional additional content to display in the history card */
  children?: React.ReactNode
  /** Optional custom className for styling */
  className?: string
}

export function HistoryCard({
  creator,
  createdAt,
  updatedAt,
  title = 'History',
  children,
  className,
}: HistoryCardProps) {
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-5 text-sm">
        <NodeUsers
          users={[creator]}
          showViewAll={false}
          avatarSize="sm"
          icon={User}
          label="Created by"
          showUserName={true}
          labelStacked={true}
        />
        <div>
          <NodeDate dueDate={createdAt} label="Created on" showOverdue={false} labelStacked />
        </div>
        <div>
          <NodeDate dueDate={updatedAt} label="Updated on" showOverdue={false} labelStacked />
        </div>
        {children}
      </CardContent>
    </Card>
  )
}
